import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NbIconModule } from '@nebular/theme';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { getContactEmail } from 'docs/app/hh_utils';

@Component({
    selector: 'ngd-footer',
    styleUrls: ['./footer.component.scss'],
    templateUrl: './footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NbIconModule, TranslateModule, RouterLink],
})
export class NgdFooterComponent {
  contactEmail = getContactEmail();
  constructor(public translate: TranslateService) {}
}
